var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"prt-section-separator"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),(typeof _vm.amount === 'number')?_c('span',{staticClass:"amount",class:{negative: _vm.amount < 0}},[_vm._v(_vm._s(_vm._f("transformAmount")(_vm.amount)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }